import { Injectable } from '@angular/core';
import { fromLegacyPromise, getAngularJSService } from '../ng-upgrade.utils';
import { NotificationListResponse, NotificationType } from '@core/models';

interface LegacyHttpResponse<T> {
  data: T;
}

interface LegacyNotificationFactory {
  getNotifications(
    type: NotificationType,
    page: number,
    limit?: number
  ): Promise<LegacyHttpResponse<NotificationListResponse>>;
  cleanNotifications(type: NotificationType): Promise<LegacyHttpResponse<void>>;
  readNotifications(type: NotificationType, vehicleId?: number): Promise<LegacyHttpResponse<void>>;
  saveDeviceToken(deviceToken: string): Promise<LegacyHttpResponse<void>>;
  deleteDeviceToken(deviceToken: string): Promise<LegacyHttpResponse<void>>;
}

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private notificationFactory: LegacyNotificationFactory | null = null;

  private get factory(): LegacyNotificationFactory {
    if (this.notificationFactory) {
      return this.notificationFactory;
    }
    const svc = getAngularJSService<LegacyNotificationFactory>('notificationFactory');
    if (!svc) {
      throw new Error(
        'notificationFactory AngularJS não disponível. AngularJS pode não ter sido bootstrapped.'
      );
    }
    this.notificationFactory = svc;
    return this.notificationFactory;
  }

  async getNotifications(
    type: NotificationType,
    page: number,
    limit?: number
  ): Promise<NotificationListResponse> {
    // WRAPPER — reescrever com HttpClient quando notificationFactory for removida
    const response = await fromLegacyPromise(this.factory.getNotifications(type, page, limit));
    return response.data;
  }

  async cleanNotifications(type: NotificationType): Promise<void> {
    // WRAPPER — reescrever com HttpClient quando notificationFactory for removida
    await fromLegacyPromise(this.factory.cleanNotifications(type));
  }

  async readNotifications(type: NotificationType, vehicleId?: number): Promise<void> {
    // WRAPPER — reescrever com HttpClient quando notificationFactory for removida
    await fromLegacyPromise(this.factory.readNotifications(type, vehicleId));
  }

  async saveDeviceToken(deviceToken: string): Promise<void> {
    // WRAPPER — reescrever com HttpClient quando notificationFactory for removida
    await fromLegacyPromise(this.factory.saveDeviceToken(deviceToken));
  }

  async deleteDeviceToken(deviceToken: string): Promise<void> {
    // WRAPPER — reescrever com HttpClient quando notificationFactory for removida
    await fromLegacyPromise(this.factory.deleteDeviceToken(deviceToken));
  }
}
